import { EXCEL_CELL_TYPES } from '../enums/excel-cell-types.enum';
import { APPLICATION_STATUSES } from '../enums/application-statuses.enum';
import { DELIVERY_METHODS } from '../enums/delivery-methods.enum';
import { NOTIFICATION_TYPES } from '../enums/notification-types.enum';
import { USER_TYPES } from '../enums/user-types.enum';
import { UI_CONSTANTS } from '@edassist/shared';
import { PAYMENT_CONFIG_FILE_EXTENSIONS } from '../enums/payment-config-file-extensions.enum';
import { PROCESS_FILTER_FIELDS } from '../enums/process-filter-fields.enum';
import { PROCESS_FILTER_CATEGORIES } from '../enums/process-filter-categories.enum';

export const constants = {
	contentConstants: {
		contentTypes: {
			global: 'global',
			general: 'general',
			LOAN: 'loan',
			PROVIDER: 'provider'
		},
		CONTENT_COMPONENTS: {
			APPLICATION_EDGOAL_AGREEMENTS: 'applicationEdGoalAgreements',
			FAST_TRACK_MARKETING_PAGE: 'fastTrackPage',
			HOME: 'home',
			WE_CAROUSEL: 'weCarousel',
			CLIENT_DOCUMENTS: 'clientDocuments',
			CAREER_PATHWAYS: 'careerPathways',
			ED_ACCESS_BANNER: 'edAccessBanner',
			REPAYMENT_BANNER: 'repaymentBanner',
			FAST_TRACK: 'fastTrack',
			MESSAGE: 'message',
			MY_ADVISING: 'myAdvising',
			APPLICATION_COURSES_EXPENSES: 'applicationCoursesExpenses',
			ED_ACCESS: 'edAccess',
			ED_ACCESS_INFO_PAGE: 'edAccessInfoPage',
			SITE: 'site',
			REVIEW_AND_SUBMIT: 'reviewAndSubmit',
			WE_NETWORK_PAGE: 'weNetworkPage',
			JUMP_START_PROVIDER: 'jumpStartProviderPage',
			JUMP_START: 'jumpStart',
			WE_EDUCATION_NETWORK: 'workforceEducationNetwork',
			LOAN_APP_STEP4: 'loanAppStep4',
			MERCHANT: 'merchant',
			LOAN_STEP_HEADERS: 'loanStepsHeaders',
			SUBMIT_DOCS: 'submitDocs',
			LANDING_PAGE: 'landingPage',
			LOGIN: 'login',
			PLATFORM_INTEGRATION: 'platformIntegration',
			PAYMENTS_STEP: 'paymentsStep',
			CONTACT_US: 'contactUs'
		},
		CONTENT_NAMES: {
			AGREEMENT: 'agreement',
			AGREEMENT_SIGNATURE_INSTRUCTIONS: 'agreementSignatureInstructions',
			PROGRAM_RESOURCES: 'programResources',
			SUPPORT_MENU_LABEL: 'supportMenuLabel',
			SITE_MAINTENANCE_NOTIFICATION_TUITION: 'siteMaintenanceNotificationTuition',
			BH_WEB_LOGO: 'bhWebLogo',
			PURPOSE_STATEMENT_HEADER: 'purposeStatementHeader',
			SESSION_QUESTION: 'sessionQuestion',
			WEN_LOGO: 'wenLogo',
			JUMPSTART_LOGO: 'jumpStartLogo',
			JUMPSTART_URL: 'jumpStartURL',
			CUSTOM_PRODUCT_URL: 'productSelectionDescription',
			ADD_EDUCATION_DETAILS: 'step1AddEducationDetails',
			WEB_LOGO: 'webLogo',
			LANDING_PAGE_INTRO_IMAGE: 'introImage',
			LANDING_PAGE_INTRO_VIDEO: 'introVideo',
			FERPA_AGREEMENT: 'ferpaAgreement',
			PAYMENT_REQUEST_INSTRUCTIONS: 'paymentRequestInstructions',
			EXPLORATION_IMAGE_1: 'explorationSurveyOption1Image',
			EXPLORATION_IMAGE_2: 'explorationSurveyOption2Image',
			EXPLORATION_IMAGE_3: 'explorationSurveyOption3Image',
			EXPLORATION_DESC_1: 'explorationSurveyOption1Description',
			EXPLORATION_DESC_2: 'explorationSurveyOption2Description',
			EXPLORATION_DESC_3: 'explorationSurveyOption3Description',
			EXPLORATION_TILE_DESC: 'explorationTileDescription',
			EXPLORATION_TILE_URL: 'explorationTileURL',
			EXPLORATION_TILE_TITLE: 'explorationTileTitle',
			EXPLORATION_SURVEY_TITLE: 'explorationSurveyTitle',
			EXPLORATION_SURVEY_DESC: 'explorationSurveyDescription'
		}
	},
	googleAnalytics: {
		actions: {
			submitForm: 'submit',
			openModal: 'open_modal',
			showApplicationCommentForm: 'show_application_comment_form',
			actionMenuItemClick: 'action_menu_item_click',
			downloadFile: 'download_file',
			editButtonToggleClick: 'edit_button_toggle_click'
		},
		benefit: {
			source: 'EdAssist',
			id: '2'
		},
		subService: {
			loanSupport: 'Student Loan Support',
			retirement: 'Retirement Enroll',
			coaching: 'Schedule Appointment',
			workforceEducation: 'Workforce Education Support',
			course: 'Added Course'
		},
		callToAction: {
			linkText: {
				tuition: 'Start Tuition Application',
				loan: 'Start Loan Application',
				scheduleCoaching: 'Schedule a Coaching Appointment',
				moreWebinars: 'More Webinars',
				registerWebinar: 'Register Webinar',
				siteMap: 'Site Map'
			},
			pageSection: {
				header: 'header',
				footer: 'footer',
				body: 'body'
			}
		},
		eventType: {
			chatInteract: 'chatInteract',
			serviceEnroll: 'serviceEnroll'
		},
		participantType: {
			returningParticipant: 'Returning Participant',
			newParticipant: 'New Participant'
		},
		form: {
			loanRequest: {
				name: 'Loan Request Form',
				field: {
					educationProgram: 'Education Program',
					fieldOfStudy: 'Field of Study',
					completionDate: 'Completion Date',
					providerSearch: 'Provider Search',
					continueBtn: 'Continue Button',
					educationProvider: 'Education Provider'
				}
			},
			careerPathways: {
				name: 'Generate Pathway Map Form'
			}
		}
	},
	routes: {
		providerSetup: 'provider-setup',
		accreditations: 'accreditations',
		integrations: 'integrations',
		home: '/home',
		orphanedQueue: '/orphaned-queue',
		system: '/system',
		programAlphaDashboard: '/programs-alpha/dashboard',
		clientDashboard: '/client/dashboard',
		provider: '/provider',
		login: '/login',
		application: '/application',
		educationGoal: '/education-goal',
		participant: '/participant',
		participantHistory: '/participant-history',
		paymentReports: '/payment-reports',
		ruleNames: '/rule-names',
		careerPathways: '/career-pathways',
		support: '/support',
		survey: '/survey',
		siteMap: '/site-map',
		task: '/task',
		workflows: '/workflows',
		payments: '/payments',
		welcome: '/welcome',
		notifications: '/tuition/notifications',
		educationAccess: {
			learnMore: '/educationAccess/learnMore'
		},
		loanRepay: {
			dashboard: 'loanRepay/dashboard',
			loanApplicationSteps: {
				loanServicer: '/add-loan-servicer'
			}
		},
		advising: 'advising',
		REVIEW_APPLICATIONS: '/review-applications',
		TUITION: {
			FAST_TRACK_MARKETING: '/fast-track/learn-more',
			ADVISING_APPOINTMENT: '/advising-appointment',
			ADVISING_SUBMISSION_CONFIRMATION: '/advising-submission-confirmation',
			WORKFORCE_EDUCATION_NETWORK: '/workforce-education/learn-more'
		},
		SSO_LOGOUT: '/sso-logout',
		ADVISING_SUBMISSION_CONFIRMATION: '/advising-submission-confirmation',
		CAREER_PATHWAYS: 'career-pathways',
		PAYMENTS_CONFIG: 'payments-config',
		CLIENT_CUSTOM_PATHWAY: 'client-custom-pathway',
		TASKS_SUMMARY: '/task/summary',
		HOME_SUMMARY: '/home/summary',
		PROFILE: '/profile',
		ACADEUM_URL: 'https://dev-edassist.acadeum.com?participantId=',
		marketplace: '/marketplace',
		LOGIN_UI: {
			WELCOME: '/start/welcome',
			ROOT: '/start',
		}
	},
	pageTitles: {
		default: 'Internal Admin - EdAssist',
		login: 'Login',
		home: 'Home',
		survey: 'Survey',
		welcome: 'Welcome',
		applicationReview: 'Application',
		participantHistory: 'History',
		participantProfile: 'Profile',
		search: 'Search',
		save: 'Save',
		client: 'Client',
		clientBeta: 'Client Setup Beta',
		orphanedDocuments: 'Orphaned Queue',
		paymentsReportsPage: 'Payment Reports',
		reviewApplications: 'Review Applications',
		NOTIFICATIONS: 'Notifications',
		advising: 'Education Coaching',
		ADVISING_APPOINTMENT: 'Schedule Advising Appointment',
		LOGOUT: 'Logout',
		ADVISING_SUBMISSION_CONFIRMATION: 'Advising Submission Confirmation',
		CAREER_PATHWAYS: 'Career Pathways',
		SITE_MAP: 'Site Map',
		EDUCATION_COACHING: 'Coaching & Resources',
		LEARNING_RESOURCES: 'Learning Resources',
		TASK: 'Tasks',
		WORKFLOWS: 'Workflows',
		PAYMENTS: 'Payments',
		PAYMENTS_BATCH_DETAILS: 'Payments Batch Details',
		PAYMENTS_CONFIG: 'Payments Configuration',
		PAYMENTS_PROCESS_FILTER_CONFIG: 'Report Filters',
		PAYMENTS_BATCH_SCHEDULED_RUNS: 'Scheduled Runs',
		FAST_TRACK_PROVIDERS: 'Fasttrack Providers',
		RULE_NAMES: 'Rule Names',
		ACCREDITATIONS: 'Accreditations',
		INTEGRATIONS: 'Integrations',
		PROVIDER_SETUP: 'Provider Setup',
		CLIENT_CUSTOM_PATHWAY: 'Custom Pathway',
		SYSTEM_EVENT_LOGS: 'System Event Logs',
		BENEFITS_AND_SUPPORT: 'Benefits & Support',
		EDUCATION_MARKET_PLACE: 'Education Marketplace'
	},
	TUITION_PAGE_TITLES: {
		HOME: 'Home',
		EDUCATION_COACHING: 'Coaching & Resources',
		ADVISING: 'Education Coaching',
		HISTORY: 'History',
		ADMIN: 'Admin',
		REVIEW_APPLICATIONS: 'Review Applications',
		CAREER_PATHWAYS: 'Career Pathways',
		LEARNING_RESOURCES: 'Learning Resources',
		BENEFITS_SUPPORT: 'Benefits & Support',
		PROFILE: 'profile'
	},
	LOAN_PAGE_TITLES: {
		HOME: 'Home',
		ADVICE_TOOLS: 'Advice & Tools',
		REQUEST_HISTORY: 'Request History'
	},
	BASE_APP_ROUTES: {
		FAST_TRACK_BASE: 'fast-track/',
		PROGRAMS_STEP: 'programs/',
		HOME: 'home',
		educationCoaching: 'advising',
		history: 'history',
		admin: 'usageOverview',
		applicationSearch: 'applicationSearch',
		profile: 'profile',
		changePassword: 'changePassword',
		application: 'application/',
		reviewApplications: 'review-applications',
		careerPathways: 'career-pathways',
		support: 'support',
		APPLICATION_DOCUMENT: 'application-document/',
		benefitsSupport: '/#/support',
		benefitsAndSupport: '/support',
		educationAccess: {
			learnMore: 'educationAccess/learnMore'
		}
	},
	LOAN_BASE_APP_ROUTES: {
		DASHBOARD: 'loanRepay/dashboard',
		REQUEST_HISTORY: 'loanRepay/paymentRequestHistory',
		ADVICE_TOOLS: 'advising'
	},
	modalIds: {
		sessionTimeout: 'sessionTimeout',
		deletePathway: 'deletePathway',
		deleteMilestone: 'deleteMilestone',
		deleteSavings: 'deleteSavings',
		deleteStep: 'deleteStep',
		resolveRule: 'resolveRule',
		editApprover: 'editApprover',
		usageOverviewDateRange: 'usageOverviewDateRange',
		ACCESS_DENIED: 'ACCESS_DENIED',
		SEARCH_EDUCATION_PROVIDER: 'searchEducationProvider',
		BENEFIT_PERIOD_CHANGE_CONFIRMATION: 'benefitPeriodChangeConfirmation',
		BENEFIT_PERIOD_FOR_READY_FOR_PAYMENT: 'bPForReadyForPayment',
		DELETE_ORPHANED_DOCUMENT: 'deleteOrphanedDocument',
		REPORT_DATA_PROBLEM: 'reportDataProblem',
		DELETE_DATA_PROBLEM: 'deleteDataProblem',
		DELETE_APPLICTION_DOCUMENT: 'deleteApplicationDocument',
		LOGOUT_CONFIRMATION: 'logoutConfirmation',
		BULK_APPROVE_CONFIRMATION: 'bulkApproveConfirmation',
		BULK_DENY_CONFIRMATION: 'bulkDenyConfirmation',
		CREATE_NEW_CLIENT: 'createNewClient',
		CREATE_NEW_PROGRAM: 'createNewProgram',
		CREATE_NEW_PARTICIPANT: 'createNewParticipant',
		CREATE_ANNUAL_TAX_LIMIT: 'createAnnualTaxLimit',
		SEARCH_APPEAL_DESIGNEE: 'searchAppealDesignee',
		UPDATE_ANNUAL_TAX_LIMIT: 'updateAnnualTaxLimit',
		CREATE_PROGRAM_GRADE: 'createProgramGrade',
		UPDATE_PROGRAM_GRADE: 'updateProgramGrade',
		PAYMENT_REVIEW: 'paymentReview',
		VOID: 'void',
		VOID_ERROR: 'voidError',
		ADD_COURSE: 'addCourse',
		PAYMENT_PORTAL: 'paymentPortal',
		CANCEL_APPOINTMENT: 'cancelAppointment',
		READY_FOR_PAYMENT: 'readyForPayment',
		CLIENT_VIEW_UNSAVED_CHANGES: 'clientViewUnsavedChanges',
		PROGRAM_VIEW_UNSAVED_CHANGES: 'programViewUnsavedChanges',
		UNREVIEWED_DOCUMENTS_COMMENTS: 'unreviewedDocumentsOrComments',
		PROGRAM_ELIGIBILITY: 'programEligibility',
		TASK_REASSIGN: 'taskReassign',
		WORKFLOW_ASSIGN: 'workflowAssign',
		ADD_TEAM_MEMBERS: 'addTeamMembers',
		GENERATE_NEW_WORKFLOW: 'generateNewWorkflow',
		ADD_PROCESSORS_TIME_OFF: 'addProcessorsTimeOffModalId',
		UPDATE_EXPENSE_TYPE: 'updateExpenseType',
		CREATE_NEW_EXPENSE_TYPE: 'createNewExpenseType',
		SUBMIT_INCOMPLETE: 'submitIncomplete',
		ADD_EDUCATION_PROVIDER: 'addEducationProvider',
		ADD_NEW_RELATED_APP: 'addNewRelatedApp',
		CARRY_OVER_PAYMENT_WARNING: 'carryOverPaymentWarning',
		ADD_NEW_COURSE_APP: 'addNewCourseApp',
		EDIT_APPLICATION_EXPENSE: 'editApplicationExpense',
		FUNDING_BATCH_APPROVE: 'fundingBatchApprove',
		FUNDING_BATCH_REJECT: 'fundingBatchReject',
		FUNDING_BATCH_COMPLETE: 'fundingBatchComplete',
		FUNDING_BATCH_RERUN: 'fundingBatchReRun',
		FUNDING_BATCH_VIEW_LOG: 'fundingBatchViewLog',
		FUNDING_BATCH_CREATE: 'fundingBatchCreate',
		FUNDING_BATCH_ALREADY_RUNNING: 'fundingBatchAlreadyRunning',
		FUNDING_BATCH_TRANSFER_FILE: 'fundingBatchTransferFile',
		PAYMENT_DETAILS_SCHEDULE_VIEW_UNSAVED_CHANGES: 'paymentsDetailScheduleCancelChanges',
		PAYMENT_DETAILS_SCHEDULE_CANCEL_CHANGES: 'paymentsDetailScheduleViewUnsavedChanges',
		PAYMENT_DETAILS_SCHEDULE_CANCEL_MODAL: 'paymentsDetailScheduleCancleModal',
		SAVE_PAYMENT_PROCESS_FILTER_CONFIG: 'saveProcessFilterConfig',
		DELETE_PAYMENT_PROCESS_FILTER_CONFIG: 'deleteProcessFilterConfig',
		SAVE_PAYMENT_SCHEDULE_INSTANCE: 'savePaymentScheduleInstance',
		DELETE_PAYMENT_SCHEDULE_INSTANCE: 'deletePaymentScheduleInstance',
		PAYMENTS_BATCH_DEFINITION_CREATE_SELECTION: 'PaymentsBatchDefinitionCreateSelection',
		PROGRAM_AGREEMENTS: 'programAgreements',
		CREATE_NEW_BENEFIT_PERIOD: 'createNewBenefitPeriod',
		EXTERNAL_NAVIGATION: 'externalNavigationConfirmation',
		ZERO_DOLLAR_PAYMENT: 'zeroDollarPayment',
		VC_PAID_AMT_MISMATCH: 'vcCardPaidAmtMismatch',
		ADD_PARTICIPANT_EXCEPTION: 'addParticipantException',
		DELETE_PARTICIPANT_EXCEPTION: 'deleteParticipantException',
		ADD_UPDATE_EXCEPTION_RULE: 'addUpdateExceptionRule',
		IMPORT_EXCEPTION_RULES: 'importExceptionRules',
		ACCREDITATION: 'accreditation',
		PARTICIPANT_EXCEPTIONS_HISTORY: 'participantExceptionsHistory',
		REMOVE_PAYMENT_FILE_COLUMN_DATA: 'removePaymentFileColumnData',
		ADD_EDIT_PAYMENT_FILE_COLUMN: 'addEditPaymentFileColumn',
		DELETE_PAYMENT_FILE_FOOTER: 'deletePaymentFileFooter',
		SAVE_PAYMENT_FILE_FOOTER: 'savePaymentFileFooter',
		DELETE_PAYMENT_FILE_HEADER: 'deletePaymentFileHeader',
		SAVE_PAYMENT_FILE_HEADER: 'savePaymentFileHeader',
		SAVE_EARNINGS_CODE: 'saveEarningsCode',
		DELETE_EARNINGS_CODE: 'deleteEarningsCode',
		SAVE_CLIENT_NOTIFICATION: 'saveClientNotification',
		DELETE_CLIENT_NOTIFICATION: 'deleteClientNotification',
		SAVE_FILE_DELIVERY_CONFIG: 'saveFileDeliveryConfig',
		DELETE_FILE_DELIVERY_CONFIG: 'deleteFileDeliveryConfig',
		ADD_SKILL: 'addSkill',
		ADD_INTEGRATION: 'addIntegration',
		DELETE_INTEGRATION: 'deleteIntegration',
		DELETE_INTEGRATION_EXCEPTION: 'deleteIntegrationException',
		ADD_PAYMENT_REQUEST: 'addPaymentRequest',
		DELETE_PROGRAM_SKILL: 'deleteProgramSkill',
		DELETE_JOB: 'deleteJob',
		DELETE_NEXT_JOB: 'deleteNextJob',
		DELETE_PREVIOUS_JOB: 'deletePreviousJob',
		DELETE_DEGREE_FOS: 'deleteDegreeFOS',
		UNREVIEWED_DOCUMENTS: 'unreviewedDocuments',
		CAREER_PATHWAY_UNSAVED_CHANGES: 'careerPathwayUnsavedChanges',
		DELETE_PROGRAM: 'deleteProgram',
		ADD_PROGRAM: 'addProgram',
		ADD_JOB: 'addJob',
		DELETE_JOB_QUALIFICATION: 'deleteJobQualification',
		SELECT_EDUCATION_PROVIDER: 'selectEducationProvider',
		AMOUNT_RECEIVED_WARNING_MODAL: 'amountReceivedWarning',
		ADD_REFUND_MODAL: 'addRefundModal',
		INITIAL_REPAY_WARNING_MODAL: 'initialRepayWarning',
		VERIFY_GRADUATION_DATE: 'verifyGraduationDate',
		CHANGE_COMPLETION_DATE: 'changeCompletionDate',
		UPLOAD_GRADUATION_DOCUMENTATION: 'uploadGraduationDocumentation',
		CONNECT_TO_LOAN_SERVICER: 'connectToLoanServicer',
		SERVICER_UNAVAILABLE: 'servicerUnavailable',
		CANCEL_LOAN_APPLICATION: 'cancelLoanApplication',
		DELETE_CLIENT_JOB: 'deleteClientJob',
		PREVIEW_CAREER_PATHWAY: 'previewCareerPathway',
		REFUND_HISTORY: 'refundHistory',
		DELETE_EXCEPTION_RULE: 'deleteExceptionRule',
		PROVIDER_ACCREDITATION_MODAL: 'providerAccreditationModal',
		PROVIDER_NETWORK_SETUP_UNSAVED_CHANGES: 'providerNetworkSetupUnsavedChanges',
		TICKET_INFORMATION: 'ticketInformation',
		ADD_PROVIDER_DOCUMENT: 'addProviderDocument',
		DELETE_PROVIDER_DOCUMENT: 'deleteProviderDocument',
		ADD_PROVIDER_SUSPENSION_MODAL: 'addProviderSuspensionModal',
		DELETE_PROVIDER_SUSPENSION_MODAL: 'deleteProviderSuspensionModal',
		EDIT_PROVIDER_SUSPENSION_MODAL: 'editProviderSuspensionModal',
		APPLICATION_WORKFLOW_MODAL: 'applicationWorkflowModal',
		DELETE_EXCEPTION: 'deleteException',
		ENROLLMENT_HISTORY: 'enrollmentHistory',
		SEARCH_BULK_APPROVER: 'searchBulkApprover',
		INVALID_FILE_ALERT_MODAL: 'invalidFileAlertModal',
		EXPLORATION_SURVEY_MODAL: 'explorationSurveyModal',
		EXPLORATION_EXTERNAL_SURVEY: 'explorationExternalSurveyModal',
		STOP_REQUEST: 'stopRequestModal',
		PARTICIPANT_CHECK_ELIGIBILITY: 'participantCheckEligibility'
	},
	sliderIds: {
		NOTIFICATION: 'notification',
		MOBILE_NAV: 'mobileNav',
		PAST_APPOINTMENT: 'pastAppointment',
		FAST_TRACK_SLIDER: 'fastTrack',
		FAST_TRACK_HOW_TO_SLIDER: 'howFastTrackWorks',
		WORKFORCE_EDUCATION_NOODLE_SLIDER: 'workForceNoodleSectionSlider',
		WORKFORCE_EDUCATION_NOODLE_PARTNER: 'workForceNoodleSectionPartner'
	},
	dropdownIds: {
		applicationHeaderActions: 'appHeaderActionMenu',
		activeApplicationActions: 'activeApplicationActionsMenu',
		expensesActions: 'dropdown.expensesActions',
		relatedApplications: 'relatedApplicationsMenu',
		linkDocumentApplications: 'dropdown.linkDocumentApplications',
		profileActions: 'dropdown.profileActions',
		supportServices: 'dropdown.supportServices',
		otherServices: 'dropdown.otherServices',
		BENEFIT_BALANCES: {
			SELECT_EDUCATION_PROGRAM: 'dropdown.benefits.selectEducationProgram',
			SELECT_DEGREE_OBJECTIVE: 'dropdown.benefits.selectDegreeObjective',
			SELECT_BENEFIT_PERIOD: 'dropdown.benefits.selectBenefitPeriod'
		},
		taskListActions: 'taskListActionsMenu',
		notificationTypesList: 'notificationTypesList'
	},
	forms: {
		advisingAppointmentForm: 'advising appointment'
	},
	loaderIds: {
		application: 'loader.application',
		appealActionsBtn: 'loader.appealActionsBtn',
		tuitionApplication: 'loader.tuitionApplication',
		loanApplication: 'loader.loanApplication',
		applicationType: 'loader.applicationType',
		applicationCourses: 'loader.applicationCourses',
		applicationCourseEditForm: 'loader.applicationCourseEditForm',
		applicationCourseAddForm: 'loader.applicationCourseAddForm',
		providerDocuments: 'loader.providerDocuments',
		applicationHistory: 'loader.applicationHistory',
		applicationReviewers: 'loader.applicationReviewers',
		applicationActionMenu: 'loader.applicationActionMenu',
		appealActionMenu: 'loader.appealActionMenu',
		workflow: 'loader.workflow',
		workflowTimeOff: 'loader.workflowTimeOff',
		paymentBatch: 'loader.payment.batch',
		paymentBatchDetails: 'loader.payment.batch.details',
		paymentBatchDetailsParentBatchDefinition: 'loader.payment.batch.details.batchDefinition.parent',
		paymentBatchLogs: 'loader.payment.batch.logs',
		supervisorTasks: 'loader.supervisorTasks',
		supervisionTab: 'loader.supervisionTab',
		supervisorTaskTab: 'loader.supervisorTaskTab',
		workflowDistributionTaskTab: 'loader.workflowDistributionTaskTab',
		BATCH_LIST_TABLE: 'loader.batchListTable',
		eventLog: 'loader.eventLog',
		addNewAlert: 'loader.addNewAlert',
		applicationDocuments: 'loader.applicationDocuments',
		dataShareDocuments: 'loader.dataShareDocuments',
		applicationTotals: 'loader.applicationTotals',
		triggerRulesSubmission: 'loader.triggerRulesSubmission',
		applicationProgram: 'loader.applicationProgram',
		participantSearchTable: 'loader.participantSearchTable',
		EDUCATION_PROVIDER_SEARCH_TABLE: 'loader.educationProviderSearchTable',
		clientSelection: 'loader.clientSelection',
		applicationExpenses: 'loader.applicationExpenses',
		saveEditPathway: 'loader.saveEditPathway',
		displayEducationPathways: 'loader.displayEducationPathways',
		saveEditPathwayMilestone: 'loader.saveEditPathwayMilestone',
		displayMilestoneSection: 'loader.displayMilestoneSection',
		AGREEMENT_CONTENT: 'loader.agreementContent',
		AGREEMENT_SIGNED_BY: 'loader.agreementSignedBy',
		APPLICATION_EDUCATION_PROVIDER: 'loader.applicationEducationProvider',
		SEARCH_EDUCATION_PROVIDER: 'loader.searchEducationProvider',
		PROVIDER_SEARCH: 'loader.providerSearch',
		PARTICIPANT: 'loader.participant',
		PARTICIPANT_ADDRESS: 'loader.participantAddress',
		PAYMENT_HISTORY: 'loader.paymentHistory',
		REFUND_DETAIL: 'loader.refundDetail',
		PARTICIPANT_REVIEWERS: 'loader.participantReviewers',
		APPLICATION_QUICK_SEARCH: 'loader.applicationQuickSearch',
		PARTICIPANT_APPLICATION_HISTORY: 'loader.participantApplicationHistory',
		PARTICIPANT_APPLICATION_HISTORY_FILTERS: 'loader.participantApplicationHistoryFilters',
		PARTICIPANT_CURRENT_EXCEPTION: 'loader.currentException',
		APPLICATION_EXPENSES: 'loader.applicationExpenses',
		APPLICATION_COURSE_EXPENSES: 'loader.applicationCourseExpenses',
		DOCUMENT_VIEWER: 'loader.documentViewer',
		DOCUMENT_ORPHANED: 'loader.orphanedDocuments',
		DOCUMENT_ORPHANED_TABLE: 'loader.orphanedDocumentsTable',
		applicationDocumentsUploadForm: 'loader.applicationDocumentsUploadForm',
		PARTICIPANT_BALANCES: 'loader.participantBalances',
		SEARCH_APPLICATIONS: 'loader.searchApplications',
		APPLICATION_DOCUMENT_VIEWER: 'loader.applicationDocumentViewer',
		DOCUMENTATION_REQUIREMENTS: 'loader.documentationRequirements',
		FAST_TRACK_PROVIDERS_TABLE: 'loader.fastTrackProvidersTable',
		APPLICATION_STUDENT_INFORMATION: 'loader.applicationStudentInformation',
		APPLICATION_STUDENT_COURSES: 'loader.applicationStudentCourses',
		SITE_REDESIGN_FEATURE: 'loader.siteRedesignFeature',
		PROGRAM_DOCUMENT_FEATURES: 'loader.programDocumentFeatures',
		PROGRAM_FEATURES: 'loader.programFeatures',
		SAVE_AUTOMATED_DOCUMENT_CONFIGURATION: 'loader.saveAutomatedDocumentConfiguration',
		NOTIFICATIONS: 'loader.notifications',
		SYSTEM_EVENT_LOGS: 'loader.systemEventLogs',
		SYSTEM_EVENT_LOGS_ACTIVITY_LOG: 'loader.systemEventLogsActivityLog',
		VIEW_DOCUMENT: 'loader.view.document',
		REVIEW_APPLICATIONS: 'loader.reviewApplications',
		CLIENT_LIST: 'loader.clientList',
		PROGRAM_LIST: 'loader.programList',
		PAYMENT_PROGRAMS_LIST: 'loader.paymentProgramList',
		CLIENT_VIEW: 'loader.clientView',
		CLIENT_VIEW_GENERAL: 'loader.clientViewGeneral',
		CLIENT_VIEW_WORKFORCE_EDUCATION: 'loader.clientViewWorkforceEducation',
		CLIENT_VIEW_PRODUCT_SETTINGS: 'loader.clientViewProductSettings',
		CLIENT_VIEW_STUDENT_LOAN_SUPPORT: 'loader.clientViewStudentLoanSupport',
		CLIENT_VIEW_PAYMENT_OPTIONS: 'loader.clientViewPaymentOptions',
		CLIENT_VIEW_REPAYMENT: 'loader.clientViewRepayment',
		CLIENT_VIEW_TAX_OPTIONS: 'loader.clientViewTaxOptions',
		CLIENT_VIEW_SUPPORT_SERVICES: 'loader.clientViewSupportServices',
		CLIENT_VIEW_PATHWAYS: 'loader.clientViewPathways',
		CLIENT_VIEW_VIRTUAL_CREDIT_CARD: 'loader.clientViewVirtualCreditCard',
		CAREER_PATHWAY: 'loader.careerPathways',
		CAREER_PATHWAY_SAVE_EDIT: 'loader.careerPathwaySaveEdit',
		RELATED_APPLICATIONS: 'loader.relatedApplications',
		ADVISING_TYPE_OF_HELP_QUESTION: 'loader.advisingTypeOfHelp',
		SAVINGS_TYPE: 'loader.savings',
		PAST_APPOINTMENT: 'loader.pastAppointment',
		ADVISING_BANNER: 'loader.advisingBanner',
		CANCEL_APPOINTMENT: 'loader.cancelAppointment',
		SAVE_PROGRAM_FEATURE_CONFIGURATION: 'loader.saveProgramFeature',
		ANNOUNCEMENT_BANNER: 'loader.announcementBanner',
		CLIENT_VIEW_MILESTONES: 'loader.clientViewMilestones',
		APPLICATION_HISTORY_DOWNLOAD: 'loader.applicationHistoryDownload',
		GENERATE_APPLICATION_PDF: 'loader.generateApplicationPdf',
		PROGRAM_VIEW_GENERAL: 'loader.programViewGeneral',
		PROGRAM_VIEW_TYPE_DETAILS: 'loader.programTypeDetails',
		PROGRAM_VIEW_PAYMENT_TYPE_DETAILS: 'loader.paymentTypeDetails',
		PROGRAM_TAX_PROGRAMS_LIST: 'loader.programTaxProgramList',
		PROGRAM_VIEW_V_CARD: 'loader.programVCard',
		PROGRAM_VIEW_PROVIDER_SETUP: 'loader.providerSetup',
		PROGRAM_GRADE_SETUP: 'loader.programGradeSetup',
		PROGRAM_GRADE_SETUP_TABLE: 'loader.programGradeSetupTable',
		PROGRAM_DEGREE_TYPE_TABLE: 'loader.programDegreeTypeTable',
		PROGRAM_VIEW_EDUCATION_DETAILS: 'loader.programViewLearningProviderDetails',
		PROGRAM_VIEW_ATTRIBUTES: 'loader.programViewAttributes',
		PAYMENTS_CONFIG_LIST: 'loader.paymentsConfigList',
		PAYMENTS_DEFINITIONS_VIEW_DETAILS_SCHEDULE: 'loader.paymentsDefinitionsViewDetailsSchedule',
		PAYMENTS_DEFINITIONS_VIEW_SCHEDULE: 'loader.paymentsDefinitionsViewSchedule',
		PAYMENTS_DEFINITIONS_VIEW_EARNINGS_CODE: 'loader.paymentsDefinitionsViewEarningsCode',
		PAYMENTS_DEFINITIONS_SAVE_EARNINGS_CODE: 'loader.paymentsDefinitionsSaveEarningsCode',
		PAYMENTS_DEFINITIONS_VIEW_FILE_COLUMNS_DATA: 'loader.paymentsDefinitionsViewFileColumnsData',
		PAYMENTS_DEFINITIONS_VIEW_FILE_FOOTERS: 'loader.paymentsDefinitionsViewFileColumnsData',
		PAYMENTS_DEFINITIONS_SAVE_FILE_FOOTERS: 'loader.paymentsDefinitionsViewFileColumnsData',
		PAYMENTS_DEFINITIONS_VIEW_FILE_HEADERS: 'loader.paymentsDefinitionsViewFileColumnsData',
		PAYMENTS_DEFINITIONS_SAVE_FILE_HEADERS: 'loader.paymentsDefinitionsViewFileColumnsData',
		PAYMENTS_DEFINITIONS_VIEW_PROCESS_FILTER: 'loader.paymentsDefinitionsViewProcessFilter',
		PAYMENTS_DEFINITIONS_VIEW_FILE_DELIVERY: 'loader.paymentsDefinitionsViewFileDelivery',
		PAYMENTS_DEFINITIONS_CREATE_REPORT_LOAD_CONFIGS: 'loader.paymentsDefinitionsViewCreateReportLoadConfigs',
		PAYMENTS_DEFINITIONS_CREATE_REPORT_LOAD_PARENT: 'loader.paymentsDefinitionsViewCreateReportLoadParent',
		PAYMENTS_DEFINITIONS_SAVE_FILE_DELIVERY: 'loader.paymentsDefinitionsSaveFileDelivery',
		PAYMENTS_DEFINITIONS_VIEW_CLIENT_NOTIFICATIONS: 'loader.paymentsDefinitionsViewClientNotifications',
		PAYMENTS_DEFINITIONS_VIEW_PROCESS_FILTER_CONFIG: 'loader.paymentsDefinitionsViewProcessFilterConfig',
		PAYMENTS_DEFINITIONS_SAVE_PROCESS_FILTER_CONFIG: 'loader.paymentsDefinitionsSaveProcessFilterConfig',
		PAYMENTS_DEFINITIONS_VIEW_SCHEDULE_INSTANCE: 'loader.paymentsViewScheduleInstance',
		PAYMENTS_DEFINITIONS_SAVE_SCHEDULE_INSTANCE: 'loader.paymentsSaveScheduleInstance',
		PAYMENTS_DEFINITIONS_VIEW_AUDIT_HISTORY: 'loader.paymentsDefinitionsViewAuditHistory',
		PAYMENTS_CREATE_BATCH_MODAL: 'loader.paymentCreateBatch',
		CREATE_NEW_EXPENSE_TYPE: 'loader.createNewExpenseTypes',
		PROVIDER_SETUP_TABLE: 'loader.providerSetupTable',
		ELIGIBLE_REQ_FREQUENCY: 'loader.eligibleReqFrequency',
		SSO_CRM_TAB: 'loader.ssoCrmTab',
		ELIGIBLE_FIELDS_OF_STUDY: 'loader.eligibleFieldsOfStudy',
		ELIGIBLE_ACCREDITATIONS: 'loader.eligibleAccreditations',
		NON_DEGREE_LEARNING_TYPES: 'loader.nonDegreeLearningTypes',
		DOCUMENT_SUBMISSION: 'loader.documentSubmission',
		NON_DEGREE_FIELD_OF_STUDY: 'loader.nonDegreeFieldOfStudy',
		VIRTUAL_CARD: 'loader.virtualCard',
		APPLICATION_DETAILS: 'loader.applicationDetails',
		ELIGIBLE_LOAN_SERVICERS: 'loader.eligibleLoanServicers',
		PROGRAM_NOTIFICATIONS: 'loader.programNotifications',
		PROGRAM_APPEALS: 'loader.programAppeals',
		BENEFIT_PERIOD_TAB: 'loader.benefitPeriodTab',
		BENEFIT_PERIOD_TABLE: 'loader.benefitPeriodTable',
		BULK_APPROVERS: 'loader.bulkApprovers',
		BENEFIT_PERIOD_GENERAL: 'loader.benefitPeriodGeneral',
		CAP_RELATED_TABLE: 'loader.capRelatedTable',
		BENEFIT_PERIOD_CAP_LIMIT: 'loader.benefitPeriodCapLimit',
		CAP_RELATED_PROGRAMS: 'loader.capRelatedPrograms',
		PAY_CYCLE_INFO: 'loader.payCycleInfo',
		PAY_CYCLE_TABLE: 'loader.payCycleTable',
		ADD_PARTICIPANT_EXCEPTION: 'loader.addParticipantException',
		ACCREDITATION_VIEW: 'loader.accreditationsView',
		ACCREDITATIONS_TABLE: 'loader.accreditationsTable',
		INTEGRATIONS_TABLE: 'loader.integrationsTable',
		EXCEPTION_RULES_TABLE: 'loader.exceptionRulesTable',
		PROGRAM_VIEW_PROVIDER_DETAILS: 'loader.programProviderTypeDetails',
		PARTICIPANT_TABLE: 'loader.participantTable',
		LOAN_INFORMATION: 'loader.loanInformation',
		LOAN_EXPENSE: 'loader.loanExpense',
		PARTICIPANT_RECENT_LOAN_PAYMENT_HISTORY: 'loader.recentLoanPaymentHistory',
		LOAN_EDUCATION_PROVIDER: 'loader.loanEducationProvider',
		LOAN_RELATED_REQUESTS: 'loader.loanRelatedRequests',
		PARTICIPANT_REPAYMENT_SETUP: 'loader.participantRepaymentSetup',
		CLIENT_SETUP_SETTINGS: 'loader.clientSetupSettings',
		LOAN_PARTICIPANT_APPLICATION_HISTORY: 'loader.loanParticipantApplicationHistory',
		LOAN_PARTICIPANT_APPLICATION_HISTORY_FILTERS: 'loader.loanParticipantApplicationHistoryFilters',
		REFUND_HISTORY: 'loader.refundHistory',
		EDUCATION_PROVIDERS_TAB: 'loader.educationProvidersTab',
		EDUCATION_PROVIDERS_TABLE: 'loader.educationProvidersTable',
		EDUCATION_PROVIDERS_VIEW: 'loader.educationProvidersView',
		PROGRAM_PROVIDERS_TABLE: 'loader.programProvidersTable',
		TAILORED_PROGRAMS: 'loader.tailoredPrograms',
		TAILORED_PROGRAMS_TABLE: 'loader.tailoredProgramsTable',
		CLIENT_PROGRAMS_TABLE: 'loader.clientProgramsTable',
		PROVIDER_ACCREDITATIONS_TABLE: 'loader.providerAccreditationsTable',
		PROVIDER_DOCUMENTS_TABLE: 'loader.providerDocumentsTable',
		EDUCATION_PROVIDERS_DETAILS: 'loader.educationProvidersDetails',
		PARTICIPANT_APP_SNAPSHOT: 'loader.participantAppSnapshot',
		PARTICIPANT_ALL_HISTORY_TABLE: 'loader.participantAllHistoryTable',
		LANDING_PAGE: 'loader.landingPage',
		PARTICIPANT_TAX_YEAR_FILTERS: 'loader.participantTaxYearFilters',
		PARTICIPANT_TAX_YEAR_SUMMARY: 'loader.participantTaxYearSummary',
		PARTICIPANT_TAX_HISTORY_TABLE: 'loader.participantTaxHistoryTable',
		GENERIC_EDITABLE_ADDRESS: 'loader.genericEditableAddress',
		PARTICIPANT_BENEFIT_BALANCES: 'loader.participantBenefitBalances',
		PROVIDER_SUSPENSION_DETAIL: 'loader.providerSuspensionDetail',
		EDUCATION_PROVIDERS_ADD: 'loader.educationProvidersAdd',
		EDIT_PROGRAM_PROVIDERS: 'loader.editProgramProviders',
		ADD_PROGRAM_PROVIDERS: 'loader.addProgramProviders',
		INVALID_FILE_ALERT: 'loader.invalidFileAlert',
		COMMENTS_TABLE: 'loader.commentsTable'
	},
	application: {
		APPLICATION_DETAIL: 'applicationDetail',
		escheatedAlert:
			'Payment for this application has been sent to state and cannot be reissued. ' +
			'Contact the Payment Admin team with questions.',
		APPS_HISTORY_FILE_NAME: 'Applications.xlsx',
		VIEW_PROGRAM_AGREEMENTS_LINK: 'View the agreements for all programs',
		programTypes: [
			{ id: 4, display: 'Tuition Direct Pay', value: 'TP' },
			{ id: 5, display: 'Tuition Reimbursement', value: 'TR' },
			{ id: 6, display: 'Expense Reimbursement', value: 'BFR' },
			{ id: 8, display: 'Loan Reimbursement', value: 'SLR' },
			{ id: 9, display: 'Loan Direct Pay', value: 'SLD' },
			{ id: 11, display: 'Tuition Virtual Credit Card', value: 'VC' },
			{ id: 12, display: 'Education Goal', value: 'EG' }
		],
		program: {
			LOAN_PROGRAM_TYPES: ['SLR', 'SLD']
		}
	},
	participant: {
		status: [
			{ display: 'Active', value: 'Y' },
			{ display: 'Inactive', value: 'N' }
		],
		participantStatusCodes: [2, 3, 6, 7, 8, 9, 11, 12],
		PAYMENT_PREFERENCE: {
			MOBILE: 'Mobile',
			EMAIL: 'Email'
		}
	},
	applicationActions: {
		approve: 'Approve',
		close: 'Close',
		cancel: 'Cancel',
		deny: 'Deny',
		appIncomplete: 'Submitted Incomplete',
		openForDocuments: 'Open For Documents',
		paymentReview: 'Payment Review',
		paymentIncomplete: 'Payment Incomplete',
		repaymentRequired: 'Repayment Required',
		readyForPayment: 'Ready For Payment',
		submitPendingReview: 'Submitted - Pending Review',
		reopenPreviousStatus: 'Reopen to Previous Status',
		appealIncomplete: 'Incomplete',
		carryOverMessage: `Based on the amount of previously paid courses, the cap limit has been reached for the current benefit period.
							This application will be carried forward to be reimbursed in a future benefit period year.
							Do you want to continue?`,
		carryOverSplitMessage: `A portion of this application can be processed for payment.
								The remaining amount will be carried forward to be paid in a future benefit period year.
								Do you want to continue?`,
		confirmation: {
			APPROVED: 'APPROVED',
			CARRY_OVER: 'CARRYOVER',
			CARRY_OVER_SPLIT: 'CARRYOVER_SPLIT',
			VC_PAID_AMT_MISMATCH: 'vcCardPaidAmtMismatch'
		}
	},
	appealActions: {
		approve: 'Approve Appeal',
		cancel: 'Cancel Appeal',
		deny: 'Deny Appeal',
		incomplete: 'Incomplete Appeal',
		forwardToDesignee: 'Forward Appeal To Designee'
	},
	applicationParticipantCommentForm: {
		commentLabel: 'Comment',
		internalNoteLabel: 'Internal Note'
	},
	localStorageKeys: {
		CURRENT_USER: 'currentUser',
		SESSION_TOKEN: 'sessionToken',
		REFRESH_TOKEN: 'refreshToken',
		PERMISSIONS_USER: 'permissions.user',
		CURRENT_USER_HYBRID: 'ngStorage-user',
		IMPERSONATION_USER: 'ngStorage-impersonation',
		TOKENS_HYBRID: 'ngStorage-session',
		ORPHANED_DOCUMENT_INDEXED: 'orphanedDocumentIndexed',
		CLIENT_DETAILS: 'ngStorage-client',
		USER_ACTIVE_PRODUCT: 'activeProduct',
		USER_ACTIVE_PATHWAY: 'activePathway',
		SELECTED_LOAN_SERVICER: 'selectedLoanServicer',
		CURRENT_USER_DETAILS_HYBRID: 'ngStorage-user.userDetails',
		CURRENT_USER_SELECTED_PROGRAM: 'ngStorage-user.userDetails.selectedProgram',
		SURVEY_PAGE_DISMISSED: 'ngStorage-user.userDetails.surveyPageDismissed',
		CLIENT_LOGIN_DETAILS: 'ngStorage-client.clientLoginDetails',
		SHOW_USER_MAINTENANCE_NOTIFICATION: 'showUserMaintenanceNotification',
		SHOW_STATIC_MESSAGE_ANNOUCEMENT: 'showStaticMessageAnnoucement',
		UNREAD_ANNOUNCEMENTS_ADMIN_REVIEW_COUNT: 'ngStorage-session.participant.unreadAnnouncementAdminReviewCount',
		NOTIFICATIONS_ACCESSED: 'ngStorage-participant',
		SCHEDULE_INSTANCE_INDEXED: 'scheduleInstanceIndexed',
		HAS_MULTIPLE_PROGRAMS: 'hasMultiplePrograms',
		HAS_ACTIVE_DIRECT_PAY_LOAN: 'hasActiveDirectPayLoan',
		CONFIGURED_LOAN_STEPS: 'configuredLoanSteps'
	},
	sessionStorageKeys: {
		PERMISSIONS_APPLICATION: 'edAssistAdmin.permissions.application',
		TASKLIST_SORT: 'edAssistAdmin.tasklist.sort',
		TASKLIST_ASSIGNEE_FILTERS: 'tasklist.filters.assignee',
		TASKLIST_CLIENT_FILTERS: 'tasklist.filters.client',
		TASKLIST_PROGRAM_TYPE_FILTERS: 'tasklist.filters.programType',
		TASKLIST_APPLICATION_STATUS_FILTERS: 'tasklist.filters.applicationStatus',
		TASKLIST_WORK_TYPE_FILTERS: 'tasklist.filters.workType',
		SUPERVISOR_TASKLIST_CLIENT_ID_FILTERS: 'supervisor.tasklist.filters.clientId',
		SUPERVISOR_TASKLIST_PROGRAM_TYPE_ID_FILTERS: 'supervisor.tasklist.filters.programTypeId',
		WORKFLOW_LIST_SORT: 'workflow.list.sort',
		WORKFLOW_SUPERVISION_EMPLOYEE_SORT: 'workflow.supervision.employee.sort',
		ORPHANED_DOCUMENTS_SORT: 'edAssistAdmin.orphaned.documents.sort',
		ORPHANED_DOCUMENTS_TAG_FILTERS: 'edAssistAdmin.orphaned.documents.filters.tag',
		ORPHANED_DOCUMENTS_SOURCE_FILTERS: 'edAssistAdmin.orphaned.documents.filters.source',
		ORPHANED_DOCUMENTS_EMAIL_FILTERS: 'edAssistAdmin.orphaned.documents.filters.email',
		SEARCH_SORT: 'edAssistAdmin.search.sort',
		PROGRAM_DOCUMENT_FEATURES_SORT: 'edAssistAdmin.programDocumentFeatures.sort',
		PROGRAM_FEATURES_SORT: 'edAssistAdmin.programFeatures.sort',
		REVIEW_APPLICATIONS_SORT: 'tuition.reviewApplications.sort',
		REVIEW_APPLICATIONS_TEAM_MEMBER: 'tuition.reviewApplications.filters.team_member',
		REVIEW_APPLICATIONS_EMPLOYER_PROGRAM: 'tuition.reviewApplications.filters.employer_program',
		REVIEW_APPLICATIONS_BENEFIT_PERIOD: 'tuition.reviewApplications.filters.benefit_period',
		WEB_ANALYTICS_INITIALIZED: 'WebAnalyticsInitialized',
		CHAT_LINGUAL_INITIALIZED: 'ChatLingualInitialized',
		FUNCTIONAL_COOKIES_OPTED_IN: 'FunctionalCookiesOptedIn',
		ONE_TRUST_ACTIVE_GROUPS: 'OTActiveGroups',
		WINDOW_RELOAD_NEEDED: 'WindowReloadNeeded',
		SUPERVISOR_TASKLIST_SORT: 'edAssistAdmin.supervisorTasklist.sort',
		SUPERVISOR_TASKLIST_ASSIGNEE_FILTERS: 'supervisorTasklist.filters.assignee',
		SUPERVISOR_TASKLIST_CLIENT_FILTERS: 'supervisorTasklist.filters.client',
		SUPERVISOR_TASKLIST_PROGRAM_TYPE_FILTERS: 'supervisorTasklist.filters.programType',
		SUPERVISOR_TASKLIST_APPLICATION_STATUS_FILTERS: 'supervisorTasklist.filters.applicationStatus',
		SUPERVISOR_TASKLIST_WORK_TYPE_FILTERS: 'supervisorTasklist.filters.workType',
		SCHEDULE_INSTANCES_SORT: 'edAssistAdmin.schedule.instances.sort',
		PAYMENT_CLIENT_FILTERS: 'payment.filters.clientName',
		PAYMENT_REPORT_NAME_FILTERS: 'payment.filters.reportName',
		PAYMENT_STATUS_FILTERS: 'payment.filters.status',
		PAYMENT_DATE_CREATED_FROM_FILTER: 'payment.filters.dateCreatedFrom',
		PAYMENT_DATE_CREATED_TO_FILTER: 'payment.filters.dateCreatedTo'
	},
	RERUN_RULES_STATUSES: [APPLICATION_STATUSES.incomplete, APPLICATION_STATUSES.pendingReview],
	editableStatuses: [
		APPLICATION_STATUSES.saved,
		APPLICATION_STATUSES.pendingReview,
		APPLICATION_STATUSES.incomplete,
		APPLICATION_STATUSES.forwardedToSupervisor
	],
	clientDashboardUserTypes: [USER_TYPES.SystemAdmin, USER_TYPES.SystemAdminWithOverride],
	hardcodedDropdownOptions: {
		genericYesNoOptions: ['Yes', 'No'],
		participantPayTypeOptions: ['Hourly', 'Salary'],
		participantStatusOptions: ['Active', 'Inactive']
	},
	PARTICIPANT_HOURLY_PAY_TYPES: ['H', 'N'],
	PARTICIPANT_SALARY_PAY_TYPES: ['S', 'Y'],
	PAYMENT_CONFIG_FREQUENCY: {
		daily: 'DAILY',
		weekly: 'WEEKLY',
		monthly: 'MONTHLY',
		specific: 'SPECIFIC'
	},
	PAYMENT_CONFIG_DROPDOWN: {
		paymentFileTypeCodeSelectionOptions: [{ value: 'PAYROLL', display: 'PAYROLL' }],
		fileExtensionSelectionOptions: [
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.CSV,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.CSV
			},
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.XLS,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.XLS
			},
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.XLSX,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.XLSX
			},
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.TXT,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.TXT
			},
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.DAT,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.DAT
			},
			{
				value: PAYMENT_CONFIG_FILE_EXTENSIONS.SAP,
				display: PAYMENT_CONFIG_FILE_EXTENSIONS.SAP
			}
		],
		csvFileDelimiterSelectionOptions: [
			{ value: ',', display: ',' },
			{ value: '|', display: '|' },
			{ value: '|"', display: '|"' }
		],
		txtFileDelimiterSelectionOptions: [
			{ value: ',', display: ',' },
			{ value: '|', display: '|' },
			{ value: '|"', display: '|"' },
			{ value: '\t', display: 'Tab' },
			{ value: 'NO_DELIMITER', display: 'No Delimiter' }
		],
		sapFileDelimiterSelectionOptions: [
			{ value: ',', display: ',' },
			{ value: '|', display: '|' },
			{ value: '|"', display: '|"' }
		],
		frequencySelectionOptions: [
			{ value: 'DAILY', display: 'Daily' },
			{ value: 'WEEKLY', display: 'Weekly' },
			{ value: 'MONTHLY', display: 'Monthly' },
			{ value: 'SPECIFIC', display: 'Variable' }
		],
		dayOfWeekSelectionOptions: [
			{ value: 1, display: 'Monday' },
			{ value: 2, display: 'Tuesday' },
			{ value: 3, display: 'Wednesday' },
			{ value: 4, display: 'Thursday' },
			{ value: 5, display: 'Friday' },
			{ value: 6, display: 'Saturday' },
			{ value: 7, display: 'Sunday' }
		],
		frequencyIntervalSelectionOptions: [
			{ value: 1, display: '1' },
			{ value: 2, display: '2' },
			{ value: 3, display: '3' },
			{ value: 4, display: '4' }
		],
		deliveryMethodSelectionOptions: [
			{ value: DELIVERY_METHODS.SFTP, display: DELIVERY_METHODS.SFTP },
			{ value: DELIVERY_METHODS.EMAIL, display: DELIVERY_METHODS.EMAIL }
		],
		taxableAmountOptions: [
			{ value: true, display: 'Taxable Amount' },
			{ value: false, display: 'Non-Taxable Amount' }
		],
		notificationTypeOptions: [
			{ value: NOTIFICATION_TYPES.EMPTY_BATCH_NOTIFICATION, display: NOTIFICATION_TYPES.EMPTY_BATCH_NOTIFICATION },
			{ value: NOTIFICATION_TYPES.CONTROL_TOTAL_NOTIFICATION, display: NOTIFICATION_TYPES.CONTROL_TOTAL_NOTIFICATION }
		]
	},
	paymentNoDelimiterPlaceholder: 'NO_DELIMITER',
	paymentFileFields: {
		paymentFileTypeCode: 'PAYROLL'
	},
	paymentFileColumnsSortingOptions: [
		{
			display: 'Ascending',
			value: 'ASC'
		},
		{
			display: 'Descending',
			value: 'DESC'
		},
		{
			display: 'Ascending (Numeric)',
			value: 'ASC-NUMERIC'
		},
		{
			display: 'Descending (Numeric)',
			value: 'DESC-NUMERIC'
		}
	],
	paymentFileColumnsExcelCellTypeOptions: [
		{ display: EXCEL_CELL_TYPES.GENERAL, value: EXCEL_CELL_TYPES.GENERAL },
		{ display: EXCEL_CELL_TYPES.NUMERIC, value: EXCEL_CELL_TYPES.NUMERIC },
		{ display: EXCEL_CELL_TYPES.CURRENCY, value: EXCEL_CELL_TYPES.CURRENCY },
		{ display: EXCEL_CELL_TYPES.TEXT, value: EXCEL_CELL_TYPES.TEXT },
		{ display: EXCEL_CELL_TYPES.CUSTOM, value: EXCEL_CELL_TYPES.CUSTOM }
	],
	paymentProcessFilterTypeOptions: [
		{ display: 'Program ID Filter', value: PROCESS_FILTER_FIELDS.PROGRAM_ID },
		{ display: 'Region Filter', value: PROCESS_FILTER_FIELDS.REGION },
		{ display: 'Company ID Filter', value: PROCESS_FILTER_FIELDS.COMPANY_ID },
		{
			display: 'Company Name Filter',
			value: PROCESS_FILTER_FIELDS.COMPANY_NAME
		},
		{ display: 'Employee Status Filter', value: PROCESS_FILTER_FIELDS.EMPLOYEE_STATUS },
		{ display: 'Generic 1 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_1 },
		{ display: 'Generic 2 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_2 },
		{ display: 'Generic 3 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_3 },
		{ display: 'Generic 4 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_4 },
		{ display: 'Generic 5 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_5 },
		{ display: 'Generic 6 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_6 },
		{ display: 'Generic 7 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_7 },
		{ display: 'Generic 8 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_8 },
		{ display: 'Generic 9 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_9 },
		{ display: 'Generic 10 Filter', value: PROCESS_FILTER_FIELDS.GENERIC_10 }
	],
	paymentProcessFilterFieldsByCategory: {
		[PROCESS_FILTER_CATEGORIES.PROGRAM_IDS]: [PROCESS_FILTER_FIELDS.PROGRAM_ID],
		[PROCESS_FILTER_CATEGORIES.APPLICATION]: [
			PROCESS_FILTER_FIELDS.REGION,
			PROCESS_FILTER_FIELDS.COMPANY_ID,
			PROCESS_FILTER_FIELDS.COMPANY_NAME,
			PROCESS_FILTER_FIELDS.EMPLOYEE_STATUS,
			PROCESS_FILTER_FIELDS.GENERIC_1,
			PROCESS_FILTER_FIELDS.GENERIC_2,
			PROCESS_FILTER_FIELDS.GENERIC_3,
			PROCESS_FILTER_FIELDS.GENERIC_4,
			PROCESS_FILTER_FIELDS.GENERIC_5,
			PROCESS_FILTER_FIELDS.GENERIC_6,
			PROCESS_FILTER_FIELDS.GENERIC_7,
			PROCESS_FILTER_FIELDS.GENERIC_8,
			PROCESS_FILTER_FIELDS.GENERIC_9,
			PROCESS_FILTER_FIELDS.GENERIC_10
		]
	},
	paymentProcessFilterUsageOptions: [
		{ display: 'Include', value: 'Include' },
		{ display: 'Exclude', value: 'Exclude' }
	],
	paymentFileFieldTypesRequireFormatting: ['DATE', 'CURRENCY'],
	paymentFileFieldRequireDefaultValue: 'HardCodedValue',
	paymentFileFieldMappingRunDateExpressionName: 'RunDateExpression',
	paymentFileFieldMappingApprovalDateExpressionName: 'BatchApprovalDateExpression',
	PAYMENT_FILE_TYPE_CONSTANTS: {
		payroll: 'PAYROLL',
		payrollControlTotal: 'PAYROLL_CONTROL_TOTAL',
		edAssistPay: 'EDASSIST_PAY'
	},
	PAYMENT_FILE_TYPE_DISPLAY_CONSTANTS: {
		PAYROLL: 'Payroll',
		PAYROLL_CONTROL_TOTAL: 'Payroll Control Total',
		EDASSIST_PAY: 'EdAssist Pay'
	},
	applicationUploadDocumentTypes: {
		grades: 'Grades'
	},
	orphanedDocumentTags: {
		incomplete: 'Incomplete',
		unreadable: 'Unreadable',
		gpStrategies: 'GpStrategies'
	},
	documentTags: {
		received: 'Received',
		incomplete: 'Incomplete',
		unusable: 'Unusable'
	},
	clientName: 'admin',
	ADMIN_CLIENT_ID: -100,
	statusChange: 'Status Change',
	userType: {
		participant: 2,
		supervisor: 3,
		clientAdmin: 7,
		proxyApplicationCreator: 8,
		superAdmin: 85,
		admin: 35,
		adminOne: 1
	},
	APPLICATION_HISTORY: {
		DEFAULT_FILTER: 'Statuses',
		NO_ITEMS: {
			STATUSES: 'No status changes exist for this application',
			COMMENTS: 'No comments exist for this application',
			EXCEPTIONS: 'No exceptions exist for this Participant.',
			DEFAULT: 'No items exist for this application'
		}
	},
	messageTypes: {
		rulesMessage: 2,
		message: 3,
		appStatusChange: 5,
		applicationException: 6,
		systemMessage: 7,
		appealStatusChange: 8,
		General: 1,
		appealReason: 11,
		participantException: 12,
		applicationExceptionDeleted: 13
	},
	pagination: {
		defaultPageSize: 10,
		dropdownAllOption: 'All'
	},
	navbar: {
		defaultAriaLabel: 'navigation'
	},
	RULES: {
		PARTICIPANT_CUSTOM_CAP_OVERRIDE: 'Participant Custom Cap Override',
		RULE_STATUS: {
			APPROVED: 'APPROVED',
			APPROVE: 'APPROVE',
			DENY: 'DENY'
		},
		DENY_APPLICATION: 'Rules did not approve this application'
	},
	GRANTS_TYPE: {
		NONE: 'None'
	},
	pathways: {
		stepTypes: {
			coaching: 'EDC',
			program: 'PGM'
		},
		NO_EDUCATION_PROVIDERS: 'Please select at least one Education Provider.'
	},
	careerPathways: {
		PROVIDERS: 'Career Pathways Providers',
		PROGRAMS: 'Career Pathways Programs',
		JOBS: 'Jobs',
		DEFAULT_COURSE_OF_STUDY: 'Search Fields of Study',
		DEFAULT_DEGREE: 'Search Degrees',
		SKILLS: 'Skills',
		PATHWAY_MAP: 'career_pathway_map',
		programs: {
			DEFAULT_CATEGORY: {
				display: 'Select Career Pathways Provider'
			}
		},
		MODAL_TITLES: {
			DELETE_PROGRAM: 'Remove Career Pathways Program',
			DELETE_DEGREE_FOS: 'Remove Degree/FOS',
			DELETE_CLIENT_JOB: 'Remove Job',
			DELETE_QUALIFICATION: 'Remove Qualification',
			ADD_JOBS: 'Add Job(s)',
			ADD_PROGRAMS: 'Add Program(s)',
			ENROLLMENT_HISTORY: 'Enrollment History'
		},
		MODAL_MESSAGES: {
			DELETE_SKILL: 'Are you sure you want to remove the Skill? This action cannot be undone.',
			DELETE_JOB: 'Are you sure you want to remove the Job? This action cannot be undone.',
			DELETE_JOB_MAPPING: 'Are you sure you want to remove the Job Mapping? This action cannot be undone.',
			DELETE_PROGRAM: 'Are you sure you want to remove the Career Pathways Program? This action cannot be undone.',
			DELETE_DEGREE_FOS: 'Are you sure you want to remove the Degree/FOS? This action cannot be undone.',
			DELETE_CLIENT_JOB: 'Are you sure you want to remove the Job? This action cannot be undone.',
			DELETE_QUALIFICATION: 'Are you sure you want to remove the Qualification? This action cannot be undone.'
		},
		DEGREE_RADIO_TYPES: {
			REQUIRED: 'REQUIRED',
			PREFERRED: 'PREFERRED'
		}
	},
	certificationTypes: {
		exam: 'Exam',
		courses: 'Courses'
	},
	program: {
		features: {
			applicationCreationComments: {
				disabled: { id: 0 },
				optional: { id: 1 },
				required: { id: 2 },
				purposeOptional: { id: 3 },
				purposeRequired: { id: 4 }
			},
			references: {
				dependent: {
					code: 'DPT',
					name: 'Dependent'
				}
			}
		}
	},
	dependent: {},
	courseOfStudy: {
		other: 55,
		unknown: 39,
		unknownDescription: 'Unknown'
	},
	degreeObjectives: {
		groupCodes: {
			nonDegree: 'NONDEG',
			degree: 'DEG',
			unknown: -1
		}
	},
	PROGRAM_FEATURES: {
		CERTIFICATION: 'certification',
		EXPORT_ACCOUNTS_PAYABLE_HELPER_TEXT:
			'Export Accounts Payable cannot be enabled for Loan Reimbursement or ' + 'Virtual Card programs.'
	},
	PROGRAM_DETERMINATION_DATE: {
		COURSE_START_DATE: 'CourseStartDate',
		COURSE_END_DATE: 'CourseEndDate',
		PAYMENT_DATE: 'PaymentDate'
	},
	expenseTypes: {
		books: 'BKS'
	},
	expenseCategory: {
		cost: 'cost',
		deduction: 'deduction',
		course: 'course',
		courseExpense: 'couExp',
		expense: 'expense'
	},
	TASKLIST_FILTER_MAP_KEYS: {
		CLIENT_NAME_MAP_KEY: 'clientName',
		PROGRAM_TYPE_CODE_MAP_KEY: 'programTypeCode',
		APP_STATUS_ID_MAP_KEY: 'applicationStatusId',
		TYPE_ID_MAP_KEY: 'typeId',
		ASSIGNEE_ID_MAP_KEY: 'assignee'
	},
	WORKFLOW_FILTER_MAP_KEYS: {
		CLIENT_NAME_MAP_KEY: 'worklowClientName',
		PROGRAM_ID_MAP_KEY: 'workflowProgramId',
		TYPE_ID_MAP_KEY: 'workflowTypeId',
		TEAM_MEMBER_ID_MAP_KEY: 'teamMemberId',
		ADD_TEAM_MEMBER_ID_MAP_KEY: 'addTeamMemberId',
		REMOVE_TEAM_MEMBER_ID_MAP_KEY: 'removeTeamMemberId',
		ADD_COORDINATORS_MAP_KEY: 'coordinators',
		ADD_SUPERVISORS_MAP_KEY: 'supervisors',
		COURSE_OF_STUDY_KEY: 'courseOfStudy'
	},
	SUPERVISOR_TASKLIST_FILTER_MAP_KEYS: {
		CLIENT_ID_MAP_KEY: 'supervisorClientId',
		PROGRAM_TYPE_ID_MAP_KEY: 'supervisorprogramTypeCode',
		APP_STATUS_ID_MAP_KEY: 'supervisorApplicationStatusId',
		TYPE_ID_MAP_KEY: 'supervisorTypeId',
		ASSIGNEE_ID_MAP_KEY: 'supervisorAssignee',
		REASSIGN_TEAM_MEMBER_ID_MAP_KEY: 'reassignTeamMemberId',
		CLIENT_ID_OTHER_MAP_KEY: 'supervisorOtherTabClientId',
		PROGRAM_TYPE_ID_OTHER_MAP_KEY: 'supervisorOtherTabProgramTypeCode',
		APP_STATUS_ID_OTHER_MAP_KEY: 'supervisorOtherTabApplicationStatusId',
		TYPE_ID_OTHER_MAP_KEY: 'supervisorOtherTabTypeId',
		ASSIGNEE_ID_OTHER_MAP_KEY: 'supervisorOtherTabAssignee',
		SLA_DAYS_MAP_KEY: 'supervisorSLADays'
	},
	SUPERVISOR_OVERVIEW_FILTER_MAP_KEYS: {
		CLIENT_MAP_KEY: 'clientName'
	},
	WORKFLOW_TIME_OFF_FILTER_MAP_KEYS: {
		SEARCH_EMPLOYEE_ID_MAP_KEY: 'searchEmployeeId',
		ADD_EMPLOYEE_ID_MAP_KEY: 'addEmployeeId'
	},
	PAYMENT_FILTER_MAP_KEYS: {
		CLIENT_NAME_MAP_KEY: 'clientName',
		REPORT_NAME_MAP_KEY: 'reportName',
		STATUS_MAP_KEY: 'statusCode',
		CREATED_FROM_DATE_PREDICATE_MAP_KEY: 'createdFromDate',
		CREATED_TO_DATE_PREDICATE_MAP_KEY: 'createdToDate'
	},
	ADDRESS_TYPES: {
		WORK: 'WRK',
		HOME: 'HOM'
	},
	PHONE_TYPES: {
		WORK: 'Work',
		HOME: 'Home',
		OTHER: 'Other'
	},
	EMAIL_TYPES: {
		WORK: 'Work',
		HOME: 'Home',
		OTHER: 'Other'
	},
	FIELD_OF_STUDY: {
		OTHER: 'Other'
	},
	LOAN_FREQUENCY_TYPE: {
		MONTHLY: 'Monthly',
		ANNUAL: 'Annual',
		ONE_TIME: 'One Time'
	},
	features: {
		program: {
			appClosingJob: 'ASC'
		}
	},
	PROGRAM_CODES: {
		EDUCATION_GOAL: 'EG'
	},
	GRADES: {
		NA: {
			ID: -1
		}
	},
	GRADUATION_BANNER: {
		applicableDegreeObjectiveIds: [2, 4, 5, 8, 9, 13, 14, 16, 20],
		notActiveApplicationIds: [90, 100, 110, 125],
		documentType: 'Proof of Graduation/Completion'
	},
	APPLICATION_DOCUMENT_VIEW: {
		DOCUMENT_ALERT_MESSAGE:
			'The data below is extracted from a submitted document. ' +
			"You must verify if this matches the participant's application",
		GRADUATION_DATE_NOT_VERIFIED: 'Graduation date must be verified before the document can be marked as Complete.'
	},
	CARD_COLORS: {
		DOCUMENT_OCR_DATA_ISSUE_CARD: 'blue'
	},
	CLIENT_FEATURES: {
		CURRENCY_CONVERSION: {
			DESCRIPTION:
				'If enabled, the conversion rates fetched through APIs will be used ' +
				'for programs enabled with Automated Currency Conversion.'
		},
		EDUCATION_PROVIDERS: 'Education Providers',
		ADD_EDUCATION_PROVIDER: 'Add Education Provider'
	},
	GRADE_FIELD_TYPES: {
		FINAL_COURSE_GRADE: 'finalCourseGrade',
		PROOF_OF_COMPLETION: 'proofOfCompletion',
		EXAM_RESULTS: 'examResults',
		PROOF_OF_ATTENDANCE: 'proofOfAttendance',
		PROOF_OF_MEMBERSHIP: 'proofOfMembership'
	},
	PRODUCTS: {
		WORKFORCE_EDUCATION: 'Workforce Education',
		WORKFORCE_EDUCATION_ID: 1,
		STUDENT_LOAN_SUPPORT: {
			ID: 2,
			NAME: 'Student Loan Support'
		},
		CLIENT_CUSTOM_PATHWAY: {
			ID: 999,
			NAME: 'Custom Pathway'
		},
		PRODUCT_TYPE_TUITION_AND_LOAN: {
			ID: -1
		}
	},
	NOTIFICATIONS: {
		YOUR_NOTIFICATIONS: 'Your Notifications',
		SLIDER_DURATION: 0.5,
		NOTIFICATIONS_NOT_FOUND: 'You don’t have any notifications yet.',
		SHOW_EMAIL: 'Show Email',
		HIDE_EMAIL: 'Hide Email',
		NOTIFICATIONS_OF: 'Notifications to',
		VIEW_NOTIFICATIONS: 'View Notifications'
	},
	programFeatures: {
		edAccess: {
			code: 'EAC',
			path: 'education-access',
			bannerConfig: 'education-access/check-banner-config',
			providerPageConfig: 'education-access/check-provider-page-config',
			edAccessDisabledParticipant: 'N'
		},
		pathways: {
			code: 'PTH',
			path: 'pathways'
		},
		FAST_TRACK: {
			code: 'FT',
			path: 'fast-track'
		}
	},
	USER_GREETING: {
		GREETING_GENERIC: 'Hello',
		GREETING_MORNING: 'Good Morning',
		GREETING_AFTERNOON: 'Good Afternoon',
		GREETING_EVENING: 'Good Evening'
	},
	CONTENT: {
		program: {
			clientDefault: 'clientDefault',
			ceuEarned: 'CEUs Earned'
		}
	},
	GENERAL: {
		HOME: {
			BENEFITS: {
				HEADER: 'Using Your Benefits',
				NO_DOCUMENTS: 'Currently there are no available documents.'
			}
		},
		CLIPBOARD: {
			COPY: 'Copy',
			COPIED: 'Copied'
		}
	},
	TUITION: {
		YES: 'Yes',
		NO: 'No',
		MORE_TEXT: 'View More',
		LESS_TEXT: 'View Less',
		EDIT: 'Edit',
		SCHEDULE_APPOINTMENT: 'Schedule a Coaching Appointment',
		EXPLORE_EDUCATION_NETWORK: 'Explore the Education Network',
		COACHING: {
			APPOINTMENT_TITLE: 'Here are your upcoming coaching appointments.',
			APPOINTMENT_DESCRIPTION:
				'Be sure to have any relevant materials handy, like admissions requirements,' +
				' policy documents, or other materials you might have questions about.',
			EDUCATION_COACH: 'Education Coach',
			STATUS: 'Status'
		},
		PAST_APPOINTMENT: {
			PAST_APPOINTMENT_TITLE: 'Previous Coaching Appointments',
			SLIDER_DURATION: 0.5
		},
		FAST_TRACK_SLIDER: {
			FAST_TRACK_FAQ_TITLE: 'FastTrack Frequently Asked Questions',
			FAST_TRACK_HOW_FT_WORKS_TITLE: 'View Details About How FastTrack Works',
			SLIDER_DURATION: 0.5
		},
		WORKFORCE_EDUCATION_NOODLE_SLIDER: {
			NOODLE_SLIDER_TITLE: 'Partner Providers',
			SLIDER_DURATION: 0.5
		},
		WORKFORCE_EDUCATION_NOODLE_PARTNER: {
			NOODLE_PARTNER_SLIDER_TITLE: 'About Education Provider',
			SLIDER_DURATION: 0.5
		},
		EDUCATION_JOURNEY: {
			content: 'When you’re ready to start your education journey, apply for approval to get the ball rolling.',
			startNewApplicationButtonText: 'Start a New Application'
		},
		NOTIFICATION: {
			recordsPerPage: 10
		},
		APPOINTMENT_STATUS: {
			SCHEDULED: 'Scheduled',
			CANCELED: 'Canceled'
		},
		ACTIVE_APPLICATION: {
			recordsPerPage: 10
		},
		ACTIVE_APPLICATION_ACTION: {
			ADD_SAVINGS: 'Add Savings',
			SUBMIT_CANCEL: 'Submit or Cancel',
			SUBMIT_PAYMENT: 'Submit Payment',
			COMPLETE_APPLICATION: 'Complete Application',
			CHOOSE_REPAYMENT_METHOD: 'Review Application',
			REPAYMENT_OWED: 'Repayment Owed',
			REVIEW_APPEAL: 'Review Appeal',
			EDIT: 'Edit',
			UPLOAD_DOCUMENTS: 'Upload Documents',
			VIEW_CREDIT_CARD: 'View Credit Card',
			ADD_OTHER_EXPENSES: 'Add Other Expenses',
			ACCESS_LETTER_OF_CREDIT: 'Access Letter of Credit',
			ADD_COURSE: 'Add Course',
			TAKE_COURSES_NOW: 'Take Your Courses Now',
			REGISTRATION_CODE_LABEL: 'Approval Code',
			COPY_REGISTRATION_CODE_LABEL: 'Copy Application Approval Code'
		},
		APPLICATION: {
			EXPENSES: {
				ADD_SAVINGS: {
					DEFAULT_REASON_OPTION_ID: 124
				}
			}
		},
		CAREER_PATHWAYS: {
			TITLE: 'Career Pathways',
			DESCRIPTION:
				"We've curated some career pathways to show estimates of how much time it will take to stack degrees" +
				' and credentials to progress in your career and earn more.',
			SELECT_A_PATHWAY: 'Select a Pathway',
			PATHWAY: 'Pathway',
			PATHWAY_DESCRIPTION:
				'These sample pathways show estimates of how much time it will take to stack degrees and credentials to' +
				' progress in your career and earn more. Click or tap a job title for education options to help get you there.',
			NOTE:
				'These recommendations are based on criteria set by education experts and coaches at EdAssist. Funding of' +
				" your education through some education programs, degrees, or providers may vary depending on your employer's policies," +
				' and may be subject to individual employee eligibility requirements. Funding is also subject to acceptance of admission' +
				' by your provider of choice.',
			AMOUNT_DESCRIPTION:
				'Amounts are based on US national averages and are not indicative of specific jobs at your employer.'
		},
		COURSE: {
			SUBSCRIPTION_INCLUDED: 'Included In Subscription',
			ADD_SUCCESS_ALERT_MESSAGE: 'Your course was successfully added.',
			ADD_FAILED_ALERT_MESSAGE: 'There was a problem adding your course. Please try again.',
			NO_COURSE_ALERT_MESSAGE: 'Please add a course to the application to create an expense application.',
			NO_BOOK_PROGRAM_ID_ALERT_MESSAGE: 'No Reimburse book program id present for the application.',
			RULES_DIDNOT_ALLOW_BOOK_EXPENSE: 'Rules did not allow to add book/expense application.'
		},
		PARTICIPANT_ALERTS: {
			ADD_SUCCESS_ALERT_MESSAGE: 'Participant Alert was successfully added.',
			ADD_FAILED_ALERT_MESSAGE: 'There was a problem adding your alert. Please try again.',
			EDIT_SUCCESS_ALERT_MESSAGE: 'Participant Alert was successfully updated.',
			EDIT_FAILED_ALERT_MESSAGE: 'There was a problem updating your alert. Please try again.',
			USER_TYPE_ID_CLOSED: 1,
			USER_TYPE_ID_OPEN: 4,
			SHOW_UNPINNED_ALERTS_LINK: 'Show Unpinned Alerts',
			HIDE_UNPINNED_ALERTS_LINK: 'Hide Unpinned Alerts',
			DEVIATION_SUBJECT_ID: 78
		},
		RELATED_APPLICATION: {
			NO_RELATED_APP_ALERT_MESSAGE: 'Please add a course to the application to create a related application.',
			NO_PROGRAM_ID_ALERT_MESSAGE: 'No Program Id present for the application.'
		},
		TAX_QUESTIONS: {
			TAX_INFO: 'taxInformation',
			TAX_QUESTION_ONE_ANSWER: 'taxQuestionOneAnswer',
			TAX_QUESTION_TWO_ANSWER: 'taxQuestionTwoAnswer',
			TAX_QUESTION_THREE_ANSWER: 'taxQuestionThreeAnswer'
		}
	},
	BULK_TYPES: {
		APPEAL: 6
	},
	REVIEW_APPLICATIONS_FILTER_MAP_KEYS: {
		TEAM_MEMBER_MAP_KEY: 'name',
		EMPLOYER_PROGRAM_MAP_KEY: 'employerProgram',
		BENEFIT_PERIOD_ID_MAP_KEY: 'benefitPeriod'
	},
	PROGRAM_TYPE_IDS: {
		ED_GOAL: 12,
		LOAN_DIRECT_PAY: 9,
		LOAN_REIMBURSEMENT: 8,
		STUDENT_LOAN_COACHING: 13,
		DEPENDENT_PROGRAM: 5
	},
	PROGRAM_TYPE_CODE: {
		BOOK_FEE: 'BFR',
		EXPENSE_REIMBURSEMENT: 'BFR',
		LOAN_REIMBURSEMENT: 'SLR',
		LOAN_DIRECT_PAY: 'SLD',
		STUDENT_LOAN_COACHING: 'EGA',
		TUITION_DIRECT_PAY: 'TP',
		TUITION_REIMBURSEMENT: 'TR',
		ED_GOAL: 'EG',
		VIRTUAL_CARD: 'VC'
	},
	TEAM_MEMBER_TYPES: {
		ME: 'me'
	},
	REPAYMENT_BANNER: {
		DOWNLOAD_CHECK_FORM:
			'Download and print the remittance form to mail along with your check.' +
			' Be sure to write the application number on the check',
		DOWNLOAD_CREDIT_CARD_FORM:
			'Download the remittance form for instructions on how to complete repayment using a credit card.',
		DEADLINE_PASSED:
			'The deadline has passed for Repayment method selection. Please reach out to your employer for additional details ' +
			'related to how to manage your Repayment.'
	},
	REPAYMENT_METHODS: {
		payroll: 'payroll',
		check: 'check',
		creditCard: 'creditcard'
	},
	COS_CATEGORIES: {
		soc: 'soc',
		archived: 'archived'
	},
	APPLICATION_TYPES: {
		educationGoal: 1100,
		application: 400,
		loanDirectPay: 700,
		loanReimbursement: 600
	},
	BULK_REVIEW_TYPES: {
		application: 1,
		educationGoal: 2
	},
	DOCUMENT_TYPES: {
		COMPLETION_DATA: 'Completion Data',
		INVOICE: 'Invoice'
	},
	PAYMENT_PORTAL_MODAL: {
		TITLE: 'Opening Third-Party Website',
		BODY:
			'By clicking "Continue", you are opening a third-party website. Please note that ' +
			'Bright Horizons privacy policy and security practices are not applicable on third-party websites.',
		WELLS_FARGO: 'Wells Fargo'
	},
	PAYMENT_CONFIGURATION: {
		NO_PAYMENT_CONFIGURATION: 'Client does not have any payment configurations.',
		NO_EARNINGS_CODES: 'Payment configuration does not have any earnings codes.',
		NO_FILE_DELIVERY_CONFIGS: 'Payment configuration does not have any file deliveries.',
		NO_PAYMENT_PROCESS_FILTER_CONFIGURATION: 'Batch Configuration does not have any payment process filter.',
		NO_FILE_COLUMNS: 'Payment configuration does not have any file columns.',
		NO_FILE_FOOTERS: 'Payment configuration does not have any file footers.',
		NO_FILE_HEADERS: 'Payment configuration does not have any custom headers configured.',
		NO_CLIENT_NOTIFICATIONS: 'Payment configuration does not have any file notifications configured.',
		NO_CLIENT_NOTIFICATIONS_CONTROL_TOTAL:
			'Client Notifications are disabled for Control total reports. The Notifications can only be configured for the parent payroll file in the respective batch configuration.',
		PAYMENT_CONFIGURATION_SCHEDULE_INSTANCES: {
			NO_PAYMENT_SCHEDULE_INSTANCES: 'Client does not have any payment scheduled runs.',
			NO_WEEKDAY_PAYMENT_SCHEDULE_INSTANCES:
				'Invalid Date Range: The selected date range only contains weekend days. Please choose a date range that includes at least one weekday.'
		},
		TAB_LABELS: {
			PAYMENT_DETAILS_SCHEDULE: 'Payment Details and Schedule',
			EARNINGS_CODES: 'Earnings Codes',
			FILE_COLUMNS_DATA: 'File Columns and Data',
			FILE_FOOTERS: 'File Footers',
			FILE_HEADERS: 'File Custom Headers',
			PROCESS_FILTERS: 'Process Filters',
			FILE_DELIVERY: 'File Delivery',
			CLIENT_NOTIFICATIONS: 'Client Notifications',
			AUDIT_CHANGES: 'Audit Changes'
		},
		ACTION_MENU_ITEMS: {
			DOWNLOAD: {
				PRELIMINARY: 'Preliminary Payroll File',
				FINAL: 'Final Payroll Report',
				CONTROL_TOTAL: 'Control Total Report'
			}
		}
	},
	EXTERNAL_LINK_MODAL: {
		TITLE: 'Opening Third-Party Website',
		BODY:
			'By clicking "Continue", you are opening a third-party website in a new browser tab. Please note that Bright Horizons privacy policy and ' +
			'security practices are not applicable on third-party websites.',
		BODY_SAME_TAB:
			'By clicking "Continue", you are opening a third-party website. Please note that Bright Horizons privacy policy and ' +
			'security practices are not applicable on third-party websites.'
	},
	ADVISING: {
		ADVISING_CATEGORY_KEYS: {
			REASON_FOR_ADVISING: 'RFSAOFS',
			HIGHEST_LEVEL_OF_EDUCATION: 'HLOEE',
			CURRENTLY_ENROLLED_IN_UNIV_PROGRAM: ''
		},
		ADVISING_CATEGORY_NAMES: {
			CURRENTLY_ENROLLED_IN_UNIV_PROGRAM: 'currentlyEnrolledInUnivProgram'
		},
		REASONS: {
			ACADEMIC: 'ACADEMIC',
			FINANCIAL: 'FINANCIAL',
			POLICY: 'POLICY',
			SUCCESS_COACHING: 'SUCCESS COACHING'
		},
		CATEGORY_ID: {
			FINANCIAL: '881840003',
			POLICY: '881840005',
			SUCCESS_COACHING: '881840006',
			ACADEMIC_POLICY: '881840000'
		},
		RESOURCES: {
			WEBINAR: 'webinar'
		},
		FORMS: {
			ADVISING_TYPE_OF_HELP: 'advisingTypeOfHelp'
		}
	},
	LOGOUT: {
		CONTENT_TEXT: 'Logging out here will end your session with all Bright Horizons benefit websites.'
	},
	BENEFIT_BALANCES: {
		YOUR_BENEFIT_BALANCES: 'Your Benefit Balances'
	},
	COUNTRIES: {
		UNITED_STATES_CODE: 'US',
		UNITED_STATES_DISPLAY: 'United States',
		UNKNOWN: 'UNKNOWN'
	},
	BANNER_TYPES: {
		ANNOUNCEMENT: 'announcement'
	},
	DEPENDENT_TITLES: {
		COURSE_NAME: 'Term',
		COURSE_NUMBER: 'Academic Calendar'
	},
	CREATE_APPLICATION: {
		OTHER: '5',
		DEPENDENT: 'dependent'
	},
	WORKFLOW: {
		MY_TASKS: 'My Tasks',
		MY_TEAM: 'My Team',
		OTHER_USERS: 'Other Users',
		OTHER_USERS_VALUE: -99,
		OTHER_PROCESSORS: 'Other Processors',
		FA_USERS: 'fa-users',
		FA_USER: 'fa-user',
		REASSIGN_TASKS: 'Reassign Task(s)',
		REASSIGN_TASKS_TEXT: 'Reassign selected task(s) to the following team member.',
		GENERATE_NEW_WORKFLOW_TEXT: 'Create new workflows for the selected client and program(s)',
		GENERATE_WORKFLOW_ALERT_TEXT: [
			'We are currently generating workflows for ',
			'. You can navigate away from the page and check back in few minutes.'
		],
		ASSIGN_WORKFLOWS: 'Assign Workflow(s)',
		ACTION_MENU_ITEM: {
			REASSIGN_TASKS: 'Reassign Selected Task(s)',
			REMOVE_TASKS: 'Remove Selected Task(s)',
			SAVE_FILTER_PREFERENCE: 'Save Filter Preferences',
			REASSIGN_WORKFLOWS: 'Reassign Selected Workflow(s)',
			REMOVE_WORKFLOWS: 'Remove Selected Workflow(s)',
			ADD_TEAM_MEMBERS: 'Add Team Member(s)',
			GENERATE_NEW_WORKFLOWS: 'Generate New Workflow(s)',
			REMOVE_SUPERVISION_MEMBERS: 'Remove Selected Member(s)',
			ADD_TIME_OFF: 'Add Time Off',
			EDIT_TIME_OFF: 'Edit Time Off',
			DELETE_TIME_OFF: 'Delete Time Off'
		},
		TABS: {
			ACTIVE_TASKS_LABEL: 'Active Tasks',
			OTHER_TASKS_LABEL: 'Other',
			OVERVIEW_TASKS_LABEL: 'Overview',
			DISTRIBUTION: 'Distribution',
			TIME_OFF: 'Time Off',
			SUPERVISION: {
				LABEL: 'Supervision',
				TIME_OFF: 'Time Off',
				EMPLOYEE: 'Employee',
				EMPLOYEE_TYPE: 'Type',
				COORDINATORS: 'Coordinators',
				COORDINATOR_BASIC: 'Coordinator (Basic)',
				COORDINATOR_ADVANCED: 'Coordinator (Advanced)',
				SUPERVISORS: 'Supervisors',
				SUPERVISOR: 'Supervisor',
				EMPLOYEE_NAME: 'Name',
				NO_USERS: 'No Users found.',
				ADD_SUPERVISION_USERS: 'Add'
			},
			FILTER_PREFERENCE_ACTIVE_TASKS: 'TASKS_ACTIVE',
			FILTER_PREFERENCE_ACTIVE_TASKS_ID: 1,
			FILTER_PREFERENCE_OVERVIEW_TASKS: 'TASKS_OVERVIEW',
			FILTER_PREFERENCE_OVERVIEW_TASKS_ID: 2
		},
		DATA_FILTER: {
			PAGE: {
				IA_TASKS: 'IA_TASKS'
			},
			TAB: {
				DEFAULT: 'DEFAULT',
				ACTIVE_TAB: 'ACTIVE',
				OTHER_TAB: 'OTHER'
			},
			FILTER: {
				PROGRAM_TYPE: 'PROGRAM_TYPE',
				WORK_TYPE: 'WORK_TYPE',
				APPLICATION_STATUS: 'APPLICATION_STATUS'
			}
		}
	},
	ADD_NEW_ALERTS: {
		DEFAULT_APP: {
			display: 'N/A',
			value: { id: 'N/A', number: 'N/A' }
		},
		DEFAULT_CATEGORY: {
			display: 'Select'
		}
	},
	PARTICIPANT_BALANCES: {
		USED_FUNDS: 'Used Funds',
		PAID_FUNDS: 'Paid Funds'
	},
	ONE_TRUST_COOKIE_TYPES: {
		STRICTLY_NECESSARY_COOKIES: 'C0001',
		PERFORMANCE_COOKIES: 'C0002',
		FUNCTIONAL_COOKIES: 'C0003',
		TARGETING_COOKIES: 'C0004',
		SOCIAL_MEDIA_COOKIES: 'C0005'
	},
	ONE_TRUST_COOKIE_PROPERTIES: {
		OPTANON: 'optanon',
		DOMAIN: '.edassist.com',
		DOMAIN_PATH: '/'
	},
	COOKIES: {
		PIN_UNAUTH: '_pin_unauth'
	},
	CLIENT_VIEW_TAB_LABELS: {
		GENERAL: 'General',
		PRODUCT_SETTINGS: 'Product Settings',
		PAYMENT_SETTINGS: 'Payment Settings',
		GENERIC_FIELDS: 'Generic Fields',
		GUIDANCE: 'Guidance',
		ADMIN_TOOLS: 'Admin Tools',
		PROGRAMS: 'Programs',
		PAYMENT_CONFIGS: 'Payment Configurations',
		CAREER_PATHWAYS: 'Career Pathways'
	},
	PROVIDER_TAB_LABELS: {
		ACCREDITATIONS: 'Accreditations',
		INTEGRATIONS: 'Integrations',
		PROVIDER_SEARCH: 'Provider Search'
	},
	InternalAdmin: {
		IA_URL_KEYWORD: 'internaladmin'
	},
	CapLimit: {
		usedFund: 2,
		paidFund: 1
	},
	ClientPrograms: {
		active: '1',
		inactive: '2'
	},
	providerSetupOptions: {
		tailoredProgram: 1,
		optionalFastTrack: 2,
		requiredFastTrack: 3
	},
	providerShareOptions: {
		flat: { display: '$', value: 1 },
		percentage: { display: '%', value: 2 }
	},
	paymentTypeOptions: {
		subscription: { display: 'Subscription', value: 1 },
		perCourse: { display: 'Per Course', value: 2 },
		perUnit: { display: 'Per Unit', value: 3 },
		determinationTypeDisplayText: {
			paymentDate: 'Payment Date',
			paymentDateValue: 'PaymentDate',
			paymentRequestDate: 'Payment Request Date'
		}
	},
	applicationActionMenuError: {
		INCOMPLETE_APPLICATION_AGREEMENTS: 'Agreements need to be signed for further processing of application.',
		INCOMPLETE_APPLICATION_COURSES: 'Courses and Expenses section is incomplete. Please complete and resubmit.',
		INCOMPLETE_APPLICATION_PROGRAMS: 'Programs section is incomplete. Please complete and resubmit.'
	},
	brightHorizonsFastTrackProviderId: 36063,
	defaultInputDropdownOption: {
		display: UI_CONSTANTS.INPUT_DROPDOWN.DEFAULT_SELECT_DISPLAY,
		value: undefined
	},
	providerSetupEnabledField: 'enabled',
	providerShareTypeField: 'providerShareType',
	paymentTypeField: 'paymentType',
	fastTrackCode: 'fastTrackCode',
	enablePayments: 'enablePayments',
	payrollDefaultFileName: 'payroll',
	degreeTypeHelperText: {
		edGoal:
			'Learning Type Details are populated by related programs and cannot be edited except to update Restrict Provider Selection in the Accreditations feature. To make a change, update the related programs.',
		expenseReimbursement:
			'Learning Type Details are populated by related programs and cannot be edited. To make a change, update the related programs.'
	},
	programTableErrorText: {
		defaultDegreeType: 'There are no Degree Types configured for this client',
		defaultNonDegreeType: 'There are no Non-Degree Types configured for this program',
		defaultFieldsOfStudy: 'There are no Fields of Study configured for this program',
		defaultNonDegreeFieldsOfStudy: 'There are no Non-Degree Fields of Study configured for this program',
		edGoalOrExpenseReimbursement: 'There are no related Payment Programs'
	},
	documentSubmission: {
		tuitionEligibleDocIds: ['APPL', 'CORR', 'CORP', 'CRSY', 'DEAU', 'GRAD', 'INVC', 'PFEN', 'PGDC', 'PPMT', 'TBRT'],
		expenseEligibleDocIds: ['APPL', 'CORR', 'CORP', 'GRAD', 'INVC', 'PPMT', 'TBRT']
	},
	accreditationsTableErrorText: {
		defaultAccreditationsTable: 'There are no Accreditations configured for this program',
		edGoalOrExpenseRe: 'There are no related Payment Programs'
	},
	eligibleRequestFreq: {
		annual: 'LFARP',
		monthly: 'LFMRP',
		onetime: 'LFOTP'
	},
	externalLinks: {
		whiteListedDomains: ['brighthorizons.com', 'bhdts.com']
	},
	studentStatus: [
		{ display: 'Full Time', value: 'Full Time' },
		{ display: 'Part Time', value: 'Part Time' }
	],
	degreeComparisonOptions: [
		{ display: 'Not Active', value: '0' },
		{ display: 'Only First Level Supervisors', value: '1' },
		{ display: 'Only Second Level Supervisors', value: '2' },
		{ display: 'First and Second Level Supervisors', value: '3' }
	],
	approvalLevelOptions: [
		{ display: '0', value: 0 },
		{ display: '1', value: 1 },
		{ display: '2', value: 2 }
	],
	availableBulkApproverTypes: [1, 3, 9, 11],
	BENEFIT_PERIOD_TYPES: {
		ANNUAL: 'Annual',
		Lifetime: 'Lifetime'
	},
	BENEFIT_PERIOD_BTN_TYPES: {
		SAVE_AND_ALIGN: 'Save and Align Benefit Period',
		SAVE_AND_MISALIGN: 'Save and Misalign Benefit Period',
		CANCEL: 'Cancel'
	},
	benefitPeriodTypeOptions: {
		monthly: 'Monthly',
		annually: 'Annual',
		lifeTime: 'Lifetime'
	},
	benefitPeriodLimitDefaults: {
		partTime: {
			benefitPeriodLimitId: undefined,
			clientCapAmount: 0,
			programCapAmount: 0,
			clientCapAmountPart: 0,
			programCapAmountPart: 0,
			benefitPeriodId: undefined,
			degreeObjectiveId: undefined,
			employmentStatus: {
				employmentStatusID: 2,
				employmentStatusDesc: 'Part-Time',
				sequenceNo: 2
			},
			programPayoutAmount: 0,
			includeInProgramLimit: false
		},
		fullTime: {
			benefitPeriodLimitId: undefined,
			clientCapAmount: 0,
			programCapAmount: 0,
			clientCapAmountPart: 0,
			programCapAmountPart: 0,
			benefitPeriodId: undefined,
			degreeObjectiveId: undefined,
			employmentStatus: {
				employmentStatusID: 1,
				employmentStatusDesc: 'Full-Time',
				sequenceNo: 1
			},
			programPayoutAmount: 0,
			includeInProgramLimit: false
		}
	},
	AMEX: {
		TRANS_NOT_AUTHORIZED: 'NOT AUTHORIZED',
		TRANS_CREDIT_INDICATOR: 'C'
	},
	PARTICIPANT_PROFILE_MSGS: {
		NO_ELIGIBLE_PROGRAMS: 'No Eligible Programs Found'
	},
	LOCAL_STORAGE: {
		API_CACHE: {
			VERSION_V1: 'v1'
		}
	},
	accreditationTable: {
		STATUS_FILTER_DEFAULT: 'Status',
		STATUS_FILTER_ACTIVE: 'active',
		STATUS_FILTER_INACTIVE: 'inactive'
	},
	rulesSearch: {
		EXCEPTION_DROPDOWN_OPTIONS: [
			{
				display: 'Yes',
				value: true
			},
			{
				display: 'No',
				value: false
			}
		],
		EXCEPTION_RULES_DELETION_MESSAGE: 'Are you sure you want to delete this rule name?',
		EXCEPTION_RULES_DELETION_ERROR: 'Rule Name cannot be deleted. One or more exceptions exist for this rule.',
		EXCEPTION_PLACEHOLDER_HELPER_TEXT:
			'Add a reason. Please include specific approval details and, if applicable, the CRM Case # documenting client approval.'
	},
	INITIAL_REPAY_WARNING_MESSAGES: {
		initialRepaymentHigherMessage: 'Initial Repayment Amount should not exceed Paid Amount.',
		initialRepaymentLowerMessage: 'Refund Amount should not exceed Initial Repayment Amount.',
		loanRefundAmountHigherMessage: 'Total refund cannot exceed paid amount.'
	},
	ADD_COURSE_EXPENSES_DISABLED_MSG: {
		ADD_COURSE_BTN_DISABLED: 'You must cancel or save edits before you can add a course.',
		ADD_EXPENSE_BTN_DISABLED: 'You must cancel or save edits before you can add an expense.'
	},
	loanStatus: {
		self: 'Self Reported',
		aggregated: 'Aggregated'
	},
	coursesOfStudyIds: {
		other: 55
	},
	appealStatus: {
		APPEAL_APPROVED: 'Appeal Approved',
		APPEAL_DENIED: 'Appeal Denied',
		APPEAL_CANCELLED: 'Appeal Cancelled',
		APPEAL_FORWARDED: 'Appeal Forwarded to Designee',
		APPEAL_INCOMPLETE: 'Appeal Incomplete',
		PENDING_REVIEW: 'Appeal Submitted - Pending Review',
		APPEAL_SAVED: 'Appeal Saved - Not Submitted'
	},
	appealStatusIds: {
		SAVED_APPEAL: 1,
		PENDING_REVIEW: 2,
		INCOMPLETE_APPEAL: 3,
		APPROVE_APPEAL: 4,
		DENY_APPEAL: 5,
		FORWARDED_APPEAL: 6,
		CANCEL_APPEAL: 7
	},
	appealApprovalLevelIds: {
		EDASSIST_ONLY: 0,
		EDASSIST_AND_APPROVER_1: 1,
		EDASSIST_AND_APPROVER_2: 2,
		EDASSIST_AND_APPEAL_DESIGNEE: 3,
		APPROVER_1: 4,
		APPROVER_2: 5,
		APPEAL_DESIGNEE: 6
	},
	APPEAL_REASON_TITLE: 'Basis for Reconsideration',
	APPEAL_REVIEWER_INACTIVE: 'Appeal Reviewer is missing or inactive',
	studentLoanTypeIdPath: '/loanAccount/studentLoanType/id',
	loanFrequencyPath: '/loanAccount/paymentFrequencyCode',
	loanRepaymentStatusPath: '/loanAccount/loanRepaymentStatus',
	BENEFIT_PERIOD_OVERLAP_ALERT_TEXT: 'Start date and End date should not overlap with other Benefit Period(s)',
	loanProgramTypes: {
		programTypeLoanReimbursementId: 8,
		programTypeLoanDirectPayId: 9
	},
	loanStepHeaderNames: {
		stepEducation: 'stepEducation',
		stepConnectLoanServicer: 'stepConnectLoanServicer',
		stepLoanDetails: 'stepLoanDetails',
		stepDocumentsAgreements: 'stepDocumentsAgreements'
	},
	loanStepNames: {
		program: 'program',
		loanServicer: 'loanServicer',
		loanDetails: 'loanDetails',
		proofOfLoan: 'proofOfLoan',
		employerPayment: 'employerPayment',
		education: 'education',
		proofOfGraduation: 'proofOfGraduation',
		benefitIntro: 'employerPayment',
		agreements: 'agreements',
		payment: 'payment',
		payments: 'payments',
		stepDocumentsAgreements: 'stepDocumentsAgreements',
		servicer: 'Servicer'
	},
	documentTypes: {
		proofOfLoan: 'Proof of Loan/Proof of Loan Payment',
		proofOfGraduationCompletion: 'Proof of Graduation/Completion'
	},
	connectLoanServicerStep: {
		searchPlaceHolder: 'Type the name of your loan servicer'
	},
	educationProvider: {
		warningMessage:
			'The provider you selected may be ineligible for this program and your request could be denied. See your policy document for details.'
	},
	providers: {
		MODAL_TITLES: {
			DELETE_PROVIDER_DOCUMENT: 'Remove Provider Document',
			ADD_PROVIDER_DOCUMENT: 'Add Provider Document'
		},
		MODAL_MESSAGES: {
			DELETE_PROVIDER_DOCUMENT: 'Are you sure you want to remove the Provider Document? This action cannot be undone.'
		},
		DOCUMENT_TYPES: {
			EEN: 'EEN',
			NON_EEN: 'non-EEN'
		},
		DSPACD: 'DSPACD'
	},
	IMPERSONATE: {
		IA: 1
	},
	TIMEZONE: 'America/Denver',
	DATE_FORMAT: 'MM/DD/YYYY',
	FILE_VALIDATION: {
		MAX_FILE_SIZE: 15728640,
		SUPPORTED_MIME_TYPES: ['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']
	}
};
